import { useState } from "react";
import { Download, Search, Trash2 } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "../../lib/api";
import { Button, Card, ErrorBox, Field, Input } from "../../components/kd";
import { DateInputDE } from "../../components/DateInputs";
import { STATUS, fmtDateTime } from "../../lib/format";

export function DsgvoSettings() {
  const [p, setP] = useState({ vorname: "", nachname: "", geburtsdatum: "" });
  const [res, setRes] = useState<any[] | null>(null);
  const [ok, setOk] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState("");
  const run = async (k: string, fn: () => Promise<void>) => { setErr(""); setBusy(k); try { await fn(); } catch (e) { setErr(errMsg(e)); } finally { setBusy(""); } };
  const search = () => run("suche", async () => { setRes((await api.post("/admin/dsgvo/suche", p)).data); });
  const auskunft = () => run("zip", async () => {
    const r = await api.post("/admin/dsgvo/auskunft", p, { responseType: "blob" });
    const a = document.createElement("a"); a.href = URL.createObjectURL(r.data); a.download = "auskunft_art15.zip"; a.click(); URL.revokeObjectURL(a.href);
  });
  const del = () => run("del", async () => {
    if (!window.confirm(`${res?.length} Fall/Fälle mit allen Dateien, Nachrichten und Berichten endgültig löschen? Dies kann nicht rückgängig gemacht werden.`)) return;
    const r = await api.post("/admin/dsgvo/loeschen", { ...p, bestaetigung: ok });
    toast.success(`${r.data.geloescht} Fall/Fälle gelöscht.`); setRes(null); setOk("");
  });
  const valid = p.nachname.trim() && p.geburtsdatum;
  return (
    <Card data-testid="dsgvo-settings">
      <h2 className="mb-1">Datenschutz: Auskunft &amp; Löschung</h2>
      <p className="mb-4 text-sm text-text-muted">Patient über Name und Geburtsdatum finden, alle Daten als ZIP exportieren (Art. 15 DSGVO) oder vollständig löschen. Das Protokoll speichert dabei keine Patientendaten.</p>
      <ErrorBox testid="dsgvo-error">{err}</ErrorBox>
      <div className="grid gap-3 sm:grid-cols-3">
        <Field label="Vorname" htmlFor="dv"><Input id="dv" value={p.vorname} onChange={(e) => setP({ ...p, vorname: e.target.value })} data-testid="dsgvo-vorname" /></Field>
        <Field label="Nachname" required htmlFor="dn"><Input id="dn" value={p.nachname} onChange={(e) => setP({ ...p, nachname: e.target.value })} data-testid="dsgvo-nachname" /></Field>
        <Field label="Geburtsdatum" required htmlFor="dg"><DateInputDE id="dg" value={p.geburtsdatum} onChange={(v) => setP({ ...p, geburtsdatum: v })} data-testid="dsgvo-geburtsdatum" /></Field>
      </div>
      <Button variant="secondary" disabled={!valid} loading={busy === "suche"} onClick={search} data-testid="dsgvo-search"><Search className="h-4 w-4" aria-hidden />Fälle suchen</Button>
      {res && (res.length === 0 ? <p className="mt-4 text-text-muted" data-testid="dsgvo-none">Keine Fälle gefunden.</p> : (
        <div className="mt-5" data-testid="dsgvo-results">
          <ul className="mb-4 divide-y divide-border rounded-lg border border-border">
            {res.map((f) => <li key={f.id} className="p-3 text-sm"><span className="font-medium">{f.fallnummer}</span> · {f.patient} · {STATUS[f.status]} · {fmtDateTime(f.erstellt_am)}</li>)}
          </ul>
          <Button onClick={auskunft} loading={busy === "zip"} data-testid="dsgvo-export"><Download className="h-4 w-4" aria-hidden />Auskunft als ZIP</Button>
          <div className="mt-5 rounded-lg border border-danger bg-danger-bg p-4">
            <p className="mb-2 text-sm">Vollständig löschen: Bitte beachten Sie die ärztliche Aufbewahrungspflicht (§ 630f BGB, 10 Jahre). Zur Bestätigung LÖSCHEN eingeben.</p>
            <div className="flex flex-col gap-2 sm:flex-row">
              <Input aria-label="Bestätigung" value={ok} onChange={(e) => setOk(e.target.value)} placeholder="LÖSCHEN" className="sm:max-w-xs" data-testid="dsgvo-delete-confirm" />
              <Button variant="danger" disabled={ok !== "LÖSCHEN"} loading={busy === "del"} onClick={del} data-testid="dsgvo-delete"><Trash2 className="h-4 w-4" aria-hidden />Patient vollständig löschen</Button>
            </div>
          </div>
        </div>
      ))}
    </Card>
  );
}
